import styled from 'styled-components';

const RecordsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  position: absolute;
  color: #e1b058;
  margin-top: 3%;

  @media (max-width: 1024px) {
    border: 3px solid #e1b058;
    border-radius: 10px;
    padding: 5%;
    background: #25132e;
  }
`;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  margin-top: 5%;
`;

const TableHeader = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  justify-content: space-between;
  font-size: 100%;
  background: linear-gradient(180deg, #392b40 0%, transparent 100%);

  @media (max-width: 560px) {
    font-size: 24px;
  }
  @media (max-width: 430px) {
    font-size: 14px;
  }

  &:last-of-type {
    border: none;
  }
`;

const TableHeaderCell = styled.div`
  height: max-content;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-of-type {
    border-right: solid 2px #554b63;
  }
  &:nth-of-type(2) {
    border-right: solid 2px #554b63;
  }
`;

const FooterCell = styled.div`
  color: #ffffff;
  height: 50px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #392b40 0%, transparent 100%);

  &:first-of-type {
    border-right: solid 2px #554b63;
  }
  &:nth-of-type(2) {
    border-right: solid 2px #554b63;
  }
`;

export const Title = styled.h2`
  font-size: 150%;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Recommend = styled.span`
  padding-top: 20px;
  text-align: center;
  font-size: 1.3vw;
  color: #e4bf30;
`;


export {
  RecordsContainer,
  TableHeaderCell,
  TableHeader,
  TableContainer,
  FooterCell,
};
